// Onboarding 2.0 (card 188) funnel instrumentation. Lucky Orange is already
// loaded globally from public/index.html; its behavior-tag events API gives us
// the signup → address → items → first-task funnel without a new vendor.
// Every call is fire-and-forget and must never break the app.

const track = (event, properties) => {
  try {
    if (window.LO && window.LO.events && typeof window.LO.events.track === 'function') {
      window.LO.events.track(event, properties);
    }
  } catch (e) {
    // analytics must never break the product
  }
};

export const ONBOARDING_EVENTS = {
  SIGNUP_COMPLETED: 'onboarding_signup_completed',
  ADDRESS_SAVED: 'onboarding_address_saved',
  RESIDENCE_TYPE_SELECTED: 'onboarding_residence_type_selected',
  QUICK_ADD_SUBMITTED: 'onboarding_quick_add_submitted',
  COMPLETED: 'onboarding_completed',
  TASK_COMPLETED: 'task_completed'
};

export default track;
